export default class PrintableResult {
    lines;
    html;
    highlight;
    constructor(lines = [], html = false, highlight = []) {
        this.lines = lines;
        this.html = html;
        this.highlight = highlight;
    }
    forPrint() {
        if (this.html) {
            return this.lines.join('');
        }
        return this.lines.join('\n');
    }
    getLines() {
        return this.lines;
    }
    getHighlight() {
        return this.highlight;
    }
}
//# sourceMappingURL=PrintableResult.js.map